import { useMutation, useQueryClient } from 'react-query';
import { getMymeParticipationAPI, PUTUpdateBlobProgressBody } from '@myme/api';
import { updateBlobProgress } from '@myme/logic';
import { handleError } from 'src/utils';

const updateBlobProgressRequest = async ({
  progress = { isFinished: true },
  mymeId,
  currentBlobId,
  currentModuleId
}: {
  progress?: PUTUpdateBlobProgressBody;
  mymeId: string;
  currentBlobId: string;
  currentModuleId: string;
}) => updateBlobProgress(mymeId, currentBlobId, { ...progress }, currentModuleId);

export const useUpdateBlobProgress = () => {
  const queryClient = useQueryClient();

  const updateBlobProgress = useMutation(updateBlobProgressRequest, {
    onSuccess: () => {
      queryClient.refetchQueries(getMymeParticipationAPI.cacheKeys);
    },
    onError: err => {
      handleError(err);
    }
  });

  return updateBlobProgress;
};
